"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactDropzone = require("react-dropzone");
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _useLabel = _interopRequireDefault(require("../../hooks/useLabel"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Img = _interopRequireDefault(require("../Image/Img"));
var _Toast = require("../Toast/Toast");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Uploader custom
 * only .jpg and .png files.
 */
const DropZone = props => {
  const {
    id: controlledId,
    placeholder,
    value,
    disabled,
    label: initialLabel,
    maxFiles,
    mimeType,
    mimeTypeError,
    previewFit,
    multiple: controlledMultiple,
    className,
    onChange
  } = props;
  const [files, setFiles] = _react.default.useState([]);
  const id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  const {
    label
  } = (0, _useLabel.default)(initialLabel, {
    ...props,
    id,
    value: files
  });
  _react.default.useEffect(() => {
    const srcToFile = async src => {
      return fetch(src).then(res => {
        return res.arrayBuffer();
      }).then(buf => {
        return new File([buf], src, {
          type: mimeType
        });
      }).then(file => {
        return Object.assign(file, {
          preview: URL.createObjectURL(file)
        });
      });
    };
    if (value) {
      if (typeof value === 'string') {
        srcToFile(value).then(file => setFiles(files => [...files, file]));
      } else {
        Promise.all(value.map(item => srcToFile(item))).then(controlledFiles => setFiles(files => [...files, ...controlledFiles]));
      }
    }
  }, [value, mimeType]);
  _react.default.useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(files);
    }
  }, [files, onChange]);
  const {
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    inputRef
  } = (0, _reactDropzone.useDropzone)({
    accept: mimeType,
    multiple: controlledMultiple,
    onDrop: acceptedFiles => {
      const newFiles = acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      }));
      if (acceptedFiles.length + files.length > maxFiles) {
        _Toast.toast.info("Maximum files/upload = " + maxFiles + " files");
      } else {
        const totalFiles = [...files, ...newFiles];
        setFiles(totalFiles);
      }
    },
    validator: f => {
      if (f.size > 20000000) {
        return {
          code: "size-too-large",
          message: "File Is Larger Than 20MB"
        };
      }
      return null;
    }
  });
  _react.default.useEffect(() => {
    const handleMimeTypeError = () => {
      const errors = fileRejections.map(item => ({
        file: item.file.name,
        message: item.errors[0].message
      }));
      errors.forEach(item => {
        _Toast.toast.error(item.file + ": " + item.message);
      });
    };
    if (typeof mimeTypeError === 'function') {
      mimeTypeError(fileRejections);
    } else {
      handleMimeTypeError();
    }
  }, [fileRejections, mimeTypeError]);
  const thumbs = files.map((file, i) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "" + file.name + i,
      className: "uk-uploader__preview uk-uploader__preview--thumb " + (controlledMultiple ? 'multiple' : '')
    }, /*#__PURE__*/_react.default.createElement(_Img.default, {
      ratio: "1/1",
      fit: previewFit,
      src: file.preview,
      alt: "preview of " + file.name
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "alert",
      size: "tiny",
      icon: "close",
      outline: true,
      className: "uk-uploader__cancel",
      onClick: () => {
        const tmp = [...files];
        const toRemove = tmp.findIndex(fileTR => file.name === fileTR.name);
        tmp.splice(toRemove, 1);
        setFiles(tmp);
      }
    }));
  });
  const list = files.map((file, i) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "" + file.name + i,
      className: "uk-uploader__preview uk-uploader__preview--list " + (controlledMultiple ? 'multiple' : '')
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "uk-uploader__file-name"
    }, file.name), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "alert",
      size: "tiny",
      icon: "close",
      className: "uk-uploader__cancel",
      outline: true,
      onClick: () => {
        const tmp = [...files];
        const toRemove = tmp.findIndex(fileTR => file.name === fileTR.name);
        tmp.splice(toRemove, 1);
        setFiles(tmp);
      }
    }));
  });
  const classes = (0, _clsx.default)('uk-uploader', 'uk-form-item', controlledMultiple && 'multiple', isDragActive && 'is-dragging', files.length > 0 && 'filled', className);
  const isTypeImage = () => Object.keys(mimeType).includes('image/*');
  return /*#__PURE__*/_react.default.createElement("section", {
    className: classes
  }, label, (!files.length || controlledMultiple) && /*#__PURE__*/_react.default.createElement("div", getRootProps({
    className: "uk-uploader__dropzone " + (disabled && 'uk-disabled')
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: inputRef,
    id: id
  }, getInputProps(), {
    multiple: controlledMultiple,
    disabled: disabled
  })), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "uk-uploader__label " + (disabled && 'uk-disabled')
  }, isDragActive ? /*#__PURE__*/_react.default.createElement("span", null, "Drop here") : /*#__PURE__*/_react.default.createElement("span", null, placeholder))), files.length > 0 && isTypeImage() ? /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-uploader__preview-zone uk-uploader__preview-zone--thumbs " + previewFit
  }, thumbs) : /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-uploader__preview-zone uk-uploader__preview-zone--list " + previewFit
  }, list), /*#__PURE__*/_react.default.createElement(_Toast.ToastContainer, null));
};
DropZone.propTypes = {
  /**
   * ID of the DropZone
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Default value of the DropZone
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  /**
   * Label of the DropZone
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Placeholder of the DropZone
   */
  placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * if image, mimeType must always start by image/ exemple: image/jpeg
   */
  mimeType: _propTypes.default.any.isRequired,
  /**
   *
   */
  previewFit: _propTypes.default.oneOf(['cover', 'contain']),
  /**
   * Show or hide the multiple files
   */
  multiple: _propTypes.default.bool,
  /**
   * Number of maximum files
   */
  maxFiles: _propTypes.default.number
};
DropZone.defaultProps = {
  placeholder: 'Drag and drop some files here, or click to select files',
  mimeType: {
    'image/*': ['.jpeg', '.png']
  },
  previewFit: 'contain',
  multiple: false,
  maxFiles: 5
};
var _default = exports.default = DropZone;